export const listStockRequisitionsQuery = `
  query ListStockRequisitions($input: ListStockRequisitionsInput) {
    listStockRequisitions(input: $input) {
      code
      requisitions {
        id
        orderNumber
        purpose
        requisitionStatus
        procurementStubId
        lines {
          stockItemId
          stockItemName
          quantity
          unit
        }
      }
    }
  }
`;

export const createStockRequisitionQuery = `
  mutation CreateStockRequisition($input: CreateStockRequisitionInput!) {
    createStockRequisition(input: $input) {
      code
      requisition {
        id
        orderNumber
        requisitionStatus
      }
    }
  }
`;

export const submitStockRequisitionQuery = `
  mutation SubmitStockRequisition($input: StockRequisitionIdInput!) {
    submitStockRequisition(input: $input) {
      code
      requisition { id requisitionStatus }
    }
  }
`;

export const approveStockRequisitionQuery = `
  mutation ApproveStockRequisition($input: StockRequisitionIdInput!) {
    approveStockRequisition(input: $input) {
      code
      requisition { id requisitionStatus }
    }
  }
`;

export const issueStockRequisitionQuery = `
  mutation IssueStockRequisition($input: StockRequisitionIdInput!) {
    issueStockRequisition(input: $input) {
      code
      requisition { id requisitionStatus }
    }
  }
`;

export const cancelStockRequisitionQuery = `
  mutation CancelStockRequisition($input: StockRequisitionIdInput!) {
    cancelStockRequisition(input: $input) {
      code
      requisition { id requisitionStatus }
    }
  }
`;
